module.exports = __webpack_public_path__ + "static/img/grade_5.f851bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_5.png
// module id = TSeB
// module chunks = 89